import { render, staticRenderFns } from "./InventoryCreateBook.vue?vue&type=template&id=b8320f0c&scoped=true&"
import script from "./InventoryCreateBook.vue?vue&type=script&lang=js&"
export * from "./InventoryCreateBook.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCreateBook.vue?vue&type=style&index=0&id=b8320f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8320f0c",
  null
  
)

export default component.exports